
/**
 * Intentionally start an asynchronous operation and disregard the resulting promise.
 * While trivial, this provides an explicit flag to the reader that the out-branch is intentional.
 * In the future, this may be required via linting rules.
 * @param func
 */
export function branch(func: () => Promise<void>) {
    func();
}